import ResizeListener from 'element-resize-detector';
export default {
  methods: {
    /* 对chart元素尺寸进行监听，当发生变化时同步更新echart视图 */
    chartEleResizeListener() {
      let _this=this
      const chartInstance = ResizeListener({
        strategy: 'scroll',
        callOnAdd: true,
        debug: true
      });
      chartInstance.listenTo(document.getElementById(_this.id), () => {
        if (!this.myChart) return;
        this.myChart.resize();
      });
    },

    /* 当窗口缩放时，echart动态调整自身大小 */
    windowResizeListener() {
      if (!this.myChart) return;
      this.myChart.resize();
    }
  },
  mounted() {
    window.addEventListener('resize', this.windowResizeListener);
    this.chartEleResizeListener();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResizeListener);
  }
}